import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgArrowRightDouble(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M9.17384 5.19719C8.78332 5.58771 8.78332 6.22088 9.17384 6.6114L13.5624 11H2.99951C2.44723 11 1.99951 11.4477 1.99951 12C1.99951 12.5523 2.44723 13 2.99951 13H13.5624L9.17384 17.3886C8.78332 17.7791 8.78332 18.4123 9.17384 18.8028C9.56437 19.1933 10.1975 19.1933 10.5881 18.8028L15.9767 13.4142C16.7577 12.6332 16.7577 11.3668 15.9767 10.5858L10.5881 5.19719C10.1975 4.80667 9.56437 4.80667 9.17384 5.19719Z", fill: "currentColor" }),
        React.createElement("path", { d: "M14.6111 6.6114C14.2206 6.22088 14.2206 5.58771 14.6111 5.19719C15.0017 4.80667 15.6348 4.80667 16.0253 5.19719L21.4139 10.5858C22.195 11.3668 22.195 12.6332 21.4139 13.4142L16.0253 18.8028C15.6348 19.1933 15.0017 19.1933 14.6111 18.8028C14.2206 18.4123 14.2206 17.7791 14.6111 17.3886L19.9997 12L14.6111 6.6114Z", fill: "currentColor" })));
}
export default SvgArrowRightDouble;
